import {Tag, TagColor} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import EditableTextField from 'ui-library/inputs/EditableTextField';
import Pane from 'ui-library/pane/Pane';

import {useDataViewContext} from './DataViewContext';
import DataViewToolbar from './DataViewToolbar';

interface DataViewPaneProps {
  children: React.ReactNode;
}

/**
 * Wrapper for `Pane` that should be used by all subcomponents of `DataView`.
 *
 * TODO(BNCH-121029): Implement functionality for this component.
 *
 * @package
 */
export default function DataViewPane({children}: DataViewPaneProps): JSX.Element {
  const {onTitleChange, title, isBetaView} = useDataViewContext();

  const titleField =
    onTitleChange != null ? (
      <EditableTextField
        value={title}
        requestChange={(newTitle: string) => {
          if (newTitle !== title) {
            onTitleChange(newTitle);
          }
        }}
      />
    ) : (
      title
    );

  return (
    <Pane
      title={
        <div className={css(styles.badgeContainer)}>
          {isBetaView && <Tag color={TagColor.BETA} text="BETA" />}
          {titleField}
        </div>
      }
      toolbar={<DataViewToolbar />}
    >
      {children}
    </Pane>
  );
}

const styles = StyleSheet.create({
  badgeContainer: {
    alignItems: 'center',
    display: 'flex',
  },
});
